export const sortTypes = {
    none: 1,
    statusAscending: 2,
    statusDescending: 3,
    dateAscending: 4,
    dateDescending: 5,
    paymentDateAscending: 6,
    paymentDateDescending: 7,
}